import { render, staticRenderFns } from "./memberBuys.vue?vue&type=template&id=68ae05ef&scoped=true&"
import script from "./memberBuys.vue?vue&type=script&lang=js&"
export * from "./memberBuys.vue?vue&type=script&lang=js&"
import style0 from "./memberBuys.vue?vue&type=style&index=0&id=68ae05ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ae05ef",
  null
  
)

export default component.exports